import React from 'react';
import '../../sass/main.scss'

const Privacy = () => {
     
 return <>
<div style={{ backgroundColor:"#fff"}}>
                   <div style={{ padding: "50px"}}>
                      <h3>POLITIKA PRIVATNOSTI</h3>
                      <p>Mi smo jedini vlasnici informacija koje se nalaze na sajtu. Imamo informacije samo one koje nam Vi samovoljno date bilo mailom bilo direktnim kontktom. Ove informacije ne mogu biti predmet trgovine. Informacije koje prikupljamo od Vas prilikom kupovine su:</p>
                  <ul>
                      <li> Ime i prezime</li>
                      <li> E-mail adresa</li>
                      <li> Adresa isporuke artikla</li>
                      <li> Broja telefona</li>
                      <li> Ime i prezime</li>
                  </ul>
                  <p>Ove informacije ćemo koristiti da odgovorimo Vašim zahtevima zbog kojih ste nas kontaktirali. Nećemo ih davati nikome van naše firme osim kada je to neophodno da bi se ispunili Vaši zahtevi, npr.da pošaljemo porudžbinu.</p>
                  <p>Ukoliko nam ne kažete drugačije, u budućnosti Vas možemo kontaktirati mailom da bi smo Vas obavestili o promocijama, popustima, novitetima, promenama na uslovima.</p>
                  <p>Imate mogućnost da prekinete bilo koji kontakt sa nama. Možete uraditi sledeće, bilo kada kontaktirajući nas, bilo mailom ili telefonom datim na sajtu:</p>
                  <ul>
                      <li>Imati uvid u naše informacije o Vama, ako uopšte i postoje</li>
                      <li>Promeniti, ispraviti, informacije koje posedujemo o Vama</li>
                      <li>Naterati nas da izbrišemo bilo koje informacije koje posedujemo o Vama</li>
                      <li>Izraziti zabrinust oko korišćenja informacija koje posedujemo o vama</li>
                  </ul>
                  <p>Posebnu pažnju posvećujemo čuvanju informacija o Vama. Kada nam poverite osetljive informacije putem sajta iste su zaštićene online i offline.

</p>
<p>Prilikom unošenja podataka o platnoj kartici, poverljive informacija se prenose putem javne
mreže u zaštićenoj (kriptovanoj) formi upotrebom SSL protokola i PKI sistema, kao trenutno
najsavremenije kriptografske tehnologije.
Sigurnost podataka prilikom kupovine, garantuje procesor platnih kartica, Banca Intesa ad
Beograd, pa se tako kompletni proces naplate obavlja na stranicama banke. Niti jednog
trenutka podaci o platnoj kartici nisu dostupni našem sistemu.</p>
<p>Kada nam dajete osetljivu informaciju (br.kreditne kartice) informacija se šifruje i prosleđuje nama sigurnim putem (https na početku adarese sajta).</p>
                  
                  <p>
                  Vaše informacije su bezbedne i offline. Serveri na kojima se čuvaju informacije su na sigurnom.

Ukoliko imate bilo kakva pitanja ili nedoumice oko zaštite privatnosti ili oko podataka kojima raspolažemo molimo Vas da nas kontaktirate.
                  </p>
                  
                  
                  
                   </div>
              </div>
        </>
}

export default Privacy;
